/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Template_Aspect_Facebook_LandscapeInputs */

const cs_template_aspect_facebook_landscape = /** @type {(inputs: Template_Aspect_Facebook_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook na šířku`)
};

const en_template_aspect_facebook_landscape = /** @type {(inputs: Template_Aspect_Facebook_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook landscape`)
};

/**
* | output |
* | --- |
* | "Facebook landscape" |
*
* @param {Template_Aspect_Facebook_LandscapeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const template_aspect_facebook_landscape = /** @type {((inputs?: Template_Aspect_Facebook_LandscapeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Aspect_Facebook_LandscapeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_aspect_facebook_landscape(inputs)
	return cs_template_aspect_facebook_landscape(inputs)
});